import { render, staticRenderFns } from "./ServiceUsage.vue?vue&type=template&id=490166db&scoped=true&"
import script from "./ServiceUsage.vue?vue&type=script&lang=js&"
export * from "./ServiceUsage.vue?vue&type=script&lang=js&"
import style0 from "./ServiceUsage.vue?vue&type=style&index=0&id=490166db&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490166db",
  null
  
)

export default component.exports